module.exports = __webpack_public_path__ + "img/feature_buy_ko.8bd24ee5.png";